module.exports = __webpack_public_path__ + "img/38.18eb3ada.png";